import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    background-color: ${displayState?.color ?? ''};
    height: 31px;
    width: 3px;
    border-radius: 10px;
    margin-right: 8px;

    @media only screen and (min-width: 768px) {
      height: 40px;
      width: 4px;
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })